import React from "react";

export default function SQL_CREATE_VIEW() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_CREATE_VIEW</h1>
      <p>This is the SQL_CREATE_VIEW component generated from the SQL JSON.</p>
    </div>
  );
}
